import React from "react";
import "./categories.css";

function CategoriesList({ mainCategoriesClass,list,listFromRedux }) {
  return (
    <React.Fragment>
      <div className={`${mainCategoriesClass} w-100 h-100 flex flex-wrap`}>
        {listFromRedux?.map((list,idx) => {
            return(<span key={idx} className="cursor-pointer select-none py-2 px-1 rounded-sm bg-gray-200 leading-3 mr-2 mb-2">{list}</span>);
          })}
      </div>
    </React.Fragment>
  );
}

export default CategoriesList;
